import { instances } from '../default-setup';

export const getDeploymentFrequencyData = (params) =>
    instances.get('dora/deployment_frequency/', params);

export const getLeadTimeData = (params) =>
    instances.get('dora/lead_time/', params);
